<template>
  <el-dialog
    :title="!dataForm.id ? 'Add Beneficial Owner' : 'Edit Beneficial Owner'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    append-to-body
    width="1100px"
    top="1vh"
  >
    <el-form :model="dataForm" ref="dataForm" label-position="top">
      <el-tabs v-model="dataForm.memberType" stretch>
        <el-tab-pane label="Company" name="CORPORATE">
          <template v-if="dataForm.memberType == 'CORPORATE'">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="Name (same as business certificate)"
                  prop="fullName"
                  :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                >
                  <el-input v-model="dataForm.fullName" placeholder="Name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Country" prop="country" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
                  <el-select style="width: 100%" v-model="dataForm.country" placeholder="Select Country">
                    <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Business No." prop="businessLicenseNo" :rules="{ required: true, message: 'Please enter', trigger: 'submit' }">
                  <el-input v-model="dataForm.businessLicenseNo" placeholder="Business No." v-regexFilter="halfWidthRegex"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Mobile"
                  prop="phone.code"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please enter',
                      trigger: 'submit',
                    },
                    { validator: validatePhone, trigger: 'submit' },
                  ]"
                >
                  <el-input v-model="dataForm.phone.code" class="input-with-select-xs" v-regexFilter="numOrPointRegex">
                    <el-select v-model="dataForm.phone.prefix" slot="prepend">
                      <el-option v-for="single in prefixOptions" :key="single.title" :value="single.value">
                        {{ single.value + " " + single.title }}
                      </el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Email"
                  prop="email"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please enter',
                      trigger: 'submit',
                    },
                    { type: 'email', message: 'Please provide a valid email address', trigger: 'submit' },
                  ]"
                >
                  <el-input v-model="dataForm.email" placeholder="Email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="!isMalaysia">
                <el-form-item
                  label="Registered Address"
                  prop="registeredOfficeAddress"
                  :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                >
                  <el-input v-model="dataForm.registeredOfficeAddress" placeholder="Company Registered Address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Operation Address"
                  prop="operationAddress"
                  :rules="{
                    required:
                      businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' || businessType == 'COMPANY_INCORPORATION'
                        ? false
                        : true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                >
                  <el-input v-model="dataForm.operationAddress" placeholder="Company Operation Address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Incorporation Date"
                  prop="incorporationDate"
                  :rules="{
                    required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                    message: 'Please select',
                    trigger: 'submit',
                  }"
                  class="fluid-width"
                >
                  <el-date-picker
                    v-model="dataForm.incorporationDate"
                    type="date"
                    placeholder="Incorporation Date"
                    value-format="yyyy-MM-dd"
                    class="fluid-width"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 马来西亚专属 - 公司额外信息 -->
              <template v-if="isMalaysia">
                <el-col :span="12">
                  <el-form-item label="Entity Type" prop="entityType">
                    <el-select style="width: 100%" v-model="dataForm.entityType" placeholder="Please select">
                      <el-option v-for="item in entityTypeList" :key="`entityType${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="Registration Number"
                    prop="companyRegistrationNumber"
                    :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                  >
                    <el-input v-model="dataForm.companyRegistrationNumber" placeholder="Registration Number"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Company Type" prop="companyType">
                    <el-select style="width: 100%" v-model="dataForm.companyType" placeholder="Please select">
                      <el-option v-for="item in companyTypeList" :key="`companyType${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Place of Incorporation" prop="placeOfIncorporation">
                    <el-input v-model="dataForm.placeOfIncorporation" placeholder="Place of Incorporation"></el-input>
                  </el-form-item>
                </el-col>
                <!-- 马来西亚专属 - REGISTERED ADDRESS -->
                <el-col :span="24" class="malaysia-address-block">
                  <p class="representativeWrap">Registered Address</p>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="Address Line 1"
                    prop="registeredAddressLine1"
                    :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                  >
                    <el-input v-model="dataForm.registeredAddressLine1" placeholder="Address Line 1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Address Line 2" prop="registeredAddressLine2">
                    <el-input v-model="dataForm.registeredAddressLine2" placeholder="Address Line 2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Address Line 3" prop="registeredAddressLine3">
                    <el-input v-model="dataForm.registeredAddressLine3" placeholder="Address Line 3"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="City" prop="registeredAddressCity">
                    <el-input v-model="dataForm.registeredAddressCity" placeholder="City"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="State" prop="registeredAddressState">
                    <el-input v-model="dataForm.registeredAddressState" placeholder="State"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Postal Code" prop="registeredAddressPostalCode">
                    <el-input v-model="dataForm.registeredAddressPostalCode" placeholder="Postal Code"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Country" prop="registeredAddressCountry">
                    <el-select style="width: 100%" v-model="dataForm.registeredAddressCountry" placeholder="Select Country" filterable>
                      <el-option v-for="item in countryList" :key="`regCountry${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 马来西亚专属 - SERVICE ADDRESS -->
                <el-col :span="24" class="malaysia-address-block">
                  <div class="representativeWrap service-address-header">
                    <span>Service Address</span>
                    <el-checkbox v-model="dataForm.serviceAddressType" :true-label="1" :false-label="2" @change="serviceAddressTypeChange">
                      Same as Registered Address
                    </el-checkbox>
                  </div>
                </el-col>
                <template v-if="dataForm.serviceAddressType !== 1">
                  <el-col :span="12">
                    <el-form-item
                      label="Address Line 1"
                      prop="serviceAddressLine1"
                      :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                    >
                      <el-input v-model="dataForm.serviceAddressLine1" placeholder="Address Line 1"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Address Line 2" prop="serviceAddressLine2">
                      <el-input v-model="dataForm.serviceAddressLine2" placeholder="Address Line 2"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Address Line 3" prop="serviceAddressLine3">
                      <el-input v-model="dataForm.serviceAddressLine3" placeholder="Address Line 3"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="City" prop="serviceAddressCity">
                      <el-input v-model="dataForm.serviceAddressCity" placeholder="City"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="State" prop="serviceAddressState">
                      <el-input v-model="dataForm.serviceAddressState" placeholder="State"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Postal Code" prop="serviceAddressPostalCode">
                      <el-input v-model="dataForm.serviceAddressPostalCode" placeholder="Postal Code"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Country" prop="serviceAddressCountry">
                      <el-select style="width: 100%" v-model="dataForm.serviceAddressCountry" placeholder="Select Country" filterable>
                        <el-option v-for="item in countryList" :key="`svcCountry${item.value}`" :label="item.title" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </template>
              </template>
            </el-row>
            <!-- representative (主体代表) -->
            <div v-if="dataForm.representativeInfo">
              <p class="representativeWrap">Representative</p>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Name (same as IC)" prop="representativeInfo.fullName">
                    <el-input v-model="dataForm.representativeInfo.fullName" placeholder="Name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Nationality" prop="representativeInfo.nationality">
                    <el-select style="width: 100%" v-model="dataForm.representativeInfo.nationality" placeholder="Select Nationality" filterable>
                      <el-option
                        v-for="item in nationalityList"
                        :key="`representativeInfoNationality${item.value}`"
                        :label="item.title"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Identification Type" prop="representativeInfo.identificationType">
                    <el-select style="width: 100%" v-model="dataForm.representativeInfo.identificationType" placeholder="Select identificationType">
                      <el-option
                        v-for="item in identificationTypeList"
                        :key="`representativeInfoIdCardType${item.value}`"
                        :label="item.title"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Identification No." prop="representativeInfo.identificationNo">
                    <el-input
                      v-model="dataForm.representativeInfo.identificationNo"
                      placeholder="Identification No."
                      v-regexFilter="halfWidthRegex"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item
                    label="Mobile No."
                    prop="representativeInfo.phone.code"
                    :rules="[{ validator: validateRepresentativePhone, trigger: 'submit' }]"
                  >
                    <el-input v-model="dataForm.representativeInfo.phone.code" class="input-with-select-xs" v-regexFilter="numOrPointRegex">
                      <el-select v-model="dataForm.representativeInfo.phone.prefix" slot="prepend">
                        <el-option v-for="single in prefixOptions" :key="`representativeInfoPrefix${single.title}`" :value="single.value">
                          {{ single.value + " " + single.title }}
                        </el-option>
                      </el-select>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="Email"
                    prop="representativeInfo.email"
                    :rules="[{ type: 'email', message: 'Please provide a valid email address', trigger: 'submit' }]"
                  >
                    <el-input v-model="dataForm.representativeInfo.email" placeholder="Email"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="Residential address" prop="representativeInfo.residentialAddress">
                    <el-input v-model="dataForm.representativeInfo.residentialAddress" placeholder="Residential address"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="Birth Date"
                    prop="representativeInfo.birthDate"
                    :rules="[{ validator: validateComeAge, trigger: 'submit' }]"
                    class="fluid-width"
                  >
                    <el-date-picker
                      v-model="dataForm.representativeInfo.birthDate"
                      type="date"
                      placeholder="Birth Date"
                      value-format="yyyy-MM-dd"
                      class="fluid-width"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane label="Individual" name="INDIVIDUAL">
          <template v-if="dataForm.memberType == 'INDIVIDUAL'">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Name (same as IC)" prop="fullName" :rules="{ required: true, message: 'Please enter', trigger: 'submit' }">
                  <el-input v-model="dataForm.fullName" placeholder="Name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Nationality" prop="nationality" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
                  <el-select style="width: 100%" v-model="dataForm.nationality" placeholder="Select Nationality">
                    <el-option v-for="item in nationalityList" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Identification Type"
                  prop="identificationType"
                  :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                >
                  <el-select style="width: 100%" v-model="dataForm.identificationType" placeholder="Select identificationType">
                    <el-option v-for="item in identificationTypeList" :key="item.value" :label="item.title" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Identification No." prop="identificationNo" :rules="{ required: true, message: 'Please enter', trigger: 'submit' }">
                  <el-input v-model="dataForm.identificationNo" placeholder="Identification No." v-regexFilter="halfWidthRegex"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Mobile"
                  prop="phone.code"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please enter',
                      trigger: 'submit',
                    },
                    { validator: validatePhone, trigger: 'submit' },
                  ]"
                >
                  <!-- <el-input v-model="dataForm.phone" placeholder="Mobile" v-regexFilter="halfWidthRegex"></el-input> -->
                  <el-input v-model="dataForm.phone.code" class="input-with-select-xs" v-regexFilter="numOrPointRegex">
                    <el-select v-model="dataForm.phone.prefix" slot="prepend">
                      <el-option v-for="single in prefixOptions" :key="single.title" :value="single.value">
                        {{ single.value + " " + single.title }}
                      </el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Email"
                  prop="email"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please enter',
                      trigger: 'submit',
                    },
                    { type: 'email', message: 'Please provide a valid email address', trigger: 'submit' },
                  ]"
                >
                  <el-input v-model="dataForm.email" placeholder="Email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="!isMalaysia">
                <el-form-item
                  label="Residential address"
                  prop="residentialAddress"
                  :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                >
                  <el-input v-model="dataForm.residentialAddress" placeholder="Residential address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Birth Date"
                  prop="birthDate"
                  :rules="[
                    {
                      required: businessType == 'COMPREHENSIVE_CUSTOMIZED' || businessType == 'FUND_ADMIN_CUSTOMIZED' ? false : true,
                      message: 'Please select',
                      trigger: 'submit',
                    },
                    { validator: validateComeAge, trigger: 'submit' },
                  ]"
                  class="fluid-width"
                >
                  <el-date-picker
                    v-model="dataForm.birthDate"
                    type="date"
                    placeholder="Birth Date"
                    value-format="yyyy-MM-dd"
                    class="fluid-width"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Does the individual hold share interest of any entity in PRC inland?"
                  prop="isHoldShareOfPrcInland"
                  :rules="{ required: true, message: 'Please select', trigger: 'submit' }"
                >
                  <el-select style="width: 100%" v-model="dataForm.isHoldShareOfPrcInland" placeholder="Please select">
                    <el-option label="Yes" :value="1"></el-option>
                    <el-option label="No" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="dataForm.isHoldShareOfPrcInland">
                <el-form-item
                  label="Please provide the name of RPC entity (1 entity is required)"
                  prop="holdShareOfPrcEntity"
                  :rules="{
                    required: true,
                    message: 'Please enter',
                    trigger: 'submit',
                  }"
                  class="fluid-width"
                >
                  <el-input v-model="dataForm.holdShareOfPrcEntity" placeholder="Please enter"></el-input>
                </el-form-item>
              </el-col>
              <!-- 马来西亚专属 - 个人额外信息 -->
              <template v-if="isMalaysia">
                <el-col :span="12">
                  <el-form-item label="Gender" prop="gender" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
                    <el-select style="width: 100%" v-model="dataForm.gender" placeholder="Please select">
                      <el-option v-for="item in genderTypeList" :key="`gender${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Occupation (e.g. Businessman, CEO, Senior Officer, etc.)" prop="occupation" :rules="{ required: true, message: 'Please enter', trigger: 'submit' }">
                    <el-input v-model="dataForm.occupation" placeholder="Occupation"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Race" prop="race" :rules="{ required: true, message: 'Please select', trigger: 'submit' }">
                    <el-select style="width: 100%" v-model="dataForm.race" placeholder="Please select" filterable>
                      <el-option v-for="item in raceTypeList" :key="`race${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 马来西亚专属 - RESIDENTIAL ADDRESS (个人类型) -->
                <el-col :span="24" class="malaysia-address-block">
                  <p class="representativeWrap">Residential Address</p>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="Address Line 1"
                    prop="residentialAddressLine1"
                    :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                  >
                    <el-input v-model="dataForm.residentialAddressLine1" placeholder="Address Line 1"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Address Line 2" prop="residentialAddressLine2">
                    <el-input v-model="dataForm.residentialAddressLine2" placeholder="Address Line 2"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Address Line 3" prop="residentialAddressLine3">
                    <el-input v-model="dataForm.residentialAddressLine3" placeholder="Address Line 3"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="City" prop="residentialAddressCity">
                    <el-input v-model="dataForm.residentialAddressCity" placeholder="City"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="State" prop="residentialAddressState">
                    <el-input v-model="dataForm.residentialAddressState" placeholder="State"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Postal Code" prop="residentialAddressPostalCode">
                    <el-input v-model="dataForm.residentialAddressPostalCode" placeholder="Postal Code"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="Country" prop="residentialAddressCountry">
                    <el-select style="width: 100%" v-model="dataForm.residentialAddressCountry" placeholder="Select Country" filterable>
                      <el-option v-for="item in countryList" :key="`resCountry${item.value}`" :label="item.title" :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- 马来西亚专属 - SERVICE ADDRESS -->
                <el-col :span="24" class="malaysia-address-block">
                  <div class="representativeWrap service-address-header">
                    <span>Service Address</span>
                    <el-checkbox v-model="dataForm.serviceAddressType" :true-label="1" :false-label="2" @change="serviceAddressTypeChange">
                      Same as Residential Address
                    </el-checkbox>
                  </div>
                </el-col>
                <template v-if="dataForm.serviceAddressType !== 1">
                  <el-col :span="12">
                    <el-form-item
                      label="Address Line 1"
                      prop="serviceAddressLine1"
                      :rules="{ required: true, message: 'Please enter', trigger: 'submit' }"
                    >
                      <el-input v-model="dataForm.serviceAddressLine1" placeholder="Address Line 1"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Address Line 2" prop="serviceAddressLine2">
                      <el-input v-model="dataForm.serviceAddressLine2" placeholder="Address Line 2"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Address Line 3" prop="serviceAddressLine3">
                      <el-input v-model="dataForm.serviceAddressLine3" placeholder="Address Line 3"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="City" prop="serviceAddressCity">
                      <el-input v-model="dataForm.serviceAddressCity" placeholder="City"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="State" prop="serviceAddressState">
                      <el-input v-model="dataForm.serviceAddressState" placeholder="State"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Postal Code" prop="serviceAddressPostalCode">
                      <el-input v-model="dataForm.serviceAddressPostalCode" placeholder="Postal Code"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="Country" prop="serviceAddressCountry">
                      <el-select style="width: 100%" v-model="dataForm.serviceAddressCountry" placeholder="Select Country" filterable>
                        <el-option v-for="item in countryList" :key="`svcCountry${item.value}`" :label="item.title" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </template>
              </template>
            </el-row>
          </template>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">Cancel</el-button>
      <el-button type="primary" @click="dataFormSubmit()">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { validateFormLocation } from "@/utils";
import validatorMixin from "@/mixins/validatorMixin";
import { mapState, mapGetters } from "vuex";
export default {
  mixins: [validatorMixin],
  props: {
    businessType: {
      type: String,
    },
    country: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
      roleList: [],
      dataForm: {
        id: 0,
        applymentId: undefined,
        memberType: "CORPORATE",
        fullName: "",
        country: "",
        nationality: "",
        identificationType: "",
        identificationNo: "",
        businessLicenseNo: "",
        email: "",
        phone: {
          prefix: "",
          code: "",
        },
        registeredOfficeAddress: "",
        operationAddress: "",
        residentialAddress: "",
        incorporationDate: "",
        birthDate: "",
        isHoldShareOfPrcInland: 0,
        holdShareOfPrcEntity: "",
        // 马来西亚专属 - 公司额外信息
        entityType: null,
        companyRegistrationNumber: null,
        companyType: null,
        placeOfIncorporation: null,
        // 马来西亚专属 - 个人额外信息
        gender: null,
        occupation: null,
        race: null,
        // 马来西亚专属 - 注册地址 (公司类型)
        registeredAddressLine1: null,
        registeredAddressLine2: null,
        registeredAddressLine3: null,
        registeredAddressCity: null,
        registeredAddressState: null,
        registeredAddressPostalCode: null,
        registeredAddressCountry: null,
        // 马来西亚专属 - 居住地址 (个人类型)
        residentialAddressLine1: null,
        residentialAddressLine2: null,
        residentialAddressLine3: null,
        residentialAddressCity: null,
        residentialAddressState: null,
        residentialAddressPostalCode: null,
        residentialAddressCountry: null,
        // 马来西亚专属 - 服务地址 (1=与注册/居住地址相同, 2=其他地址)
        serviceAddressType: 2,
        serviceAddressLine1: null,
        serviceAddressLine2: null,
        serviceAddressLine3: null,
        serviceAddressCity: null,
        serviceAddressState: null,
        serviceAddressPostalCode: null,
        serviceAddressCountry: null,
        // representative (主体代表)
        representativeInfo: {
          fullName: null,
          nationality: null,
          identificationType: null,
          identificationNo: null,
          email: null,
          phone: {
            prefix: "",
            code: "",
          },
          residentialAddress: null,
          birthDate: null,
        },
      },
      initialDataForm: {},
      introduction: {
        idx: null,
        paramName: null,
      },
    };
  },
  mounted() {
    this.initialDataForm = JSON.parse(JSON.stringify(this.dataForm));
  },
  computed: {
    ...mapState("constant", ["countryList", "nationalityList", "currencyOptions", "prefixOptions", "genderTypeList"]),
    ...mapGetters("constant", ["byCountryFormatList"]),
    isMalaysia() {
      return this.country === "Malaysia";
    },
    identificationTypeList() {
      return this.byCountryFormatList("identificationTypeData", this.country);
    },
    entityTypeList() {
      return this.byCountryFormatList("entityTypeData", this.country);
    },
    companyTypeList() {
      return this.byCountryFormatList("companyTypeData", this.country);
    },
    raceTypeList() {
      return this.byCountryFormatList("raceTypeData", this.country);
    },
  },
  methods: {
    // 马来西亚 - 服务地址"同注册/居住地址"勾选变化
    serviceAddressTypeChange(val) {
      if (val === 1) {
        this.$nextTick(() => {
          this.$refs.dataForm.clearValidate([
            "serviceAddressLine1",
            "serviceAddressLine2",
            "serviceAddressLine3",
            "serviceAddressCity",
            "serviceAddressState",
            "serviceAddressPostalCode",
            "serviceAddressCountry",
          ]);
        });
      }
    },
    // 初始化
    async init(idx, paramName, data) {
      this.introduction = {
        idx: idx,
        paramName: paramName,
      };
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (idx == "add") {
        this.dataForm = JSON.parse(JSON.stringify(this.initialDataForm));
      } else {
        const copy = JSON.parse(JSON.stringify(data));
        const copy02 = JSON.parse(JSON.stringify(data));
        // 国家 或 国籍
        console.log(data);
        if (copy.memberType == "CORPORATE") {
          copy.country = copy02.nationality;
          copy.nationality = "";
        } else {
          copy.country = "";
        }

        // representative (主体代表)
        if (copy.memberType == "CORPORATE") {
          if (copy.representativeInfo) {
            // Mobile No.
            const phoneStr = copy.representativeInfo.phone;
            const phoneSplit = phoneStr.split("-");
            const prefixNub = phoneSplit && phoneSplit[0] ? phoneSplit[0] : "";
            const codeNub = phoneSplit && phoneSplit[1] ? phoneSplit[1] : "";
            copy.representativeInfo.phone = {
              prefix: prefixNub,
              code: codeNub,
            };
          } else {
            copy.representativeInfo = {
              fullName: null,
              nationality: null,
              identificationType: null,
              identificationNo: null,
              email: null,
              phone: {
                prefix: "",
                code: "",
              },
              residentialAddress: null,
              birthDate: null,
            };
          }
        } else {
          copy.representativeInfo = {
            fullName: null,
            nationality: null,
            identificationType: null,
            identificationNo: null,
            email: null,
            phone: {
              prefix: "",
              code: "",
            },
            residentialAddress: null,
            birthDate: null,
          };
        }

        // Mobile
        let phoneCopy = copy.phone;
        let prefixCopy = phoneCopy.split("-") && phoneCopy.split("-")[0] ? phoneCopy.split("-")[0] : "";
        let codeCopy = phoneCopy.split("-") && phoneCopy.split("-")[1] ? phoneCopy.split("-")[1] : "";
        copy.phone = {
          prefix: prefixCopy,
          code: codeCopy,
        };
        // 合并默认值，确保马来西亚专属字段存在 (兼容旧数据)
        const defaults = JSON.parse(JSON.stringify(this.initialDataForm));
        this.dataForm = { ...defaults, ...copy };
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(async (valid, object) => {
        if (valid) {
          const dataFormCopy = JSON.parse(JSON.stringify(this.dataForm));
          // 数据处理
          if (dataFormCopy.memberType == "CORPORATE") {
            dataFormCopy.nationality = dataFormCopy.country;
          }

          // representative (主体代表)
          // Mobile No.
          const phoneItem = dataFormCopy.representativeInfo.phone;
          dataFormCopy.representativeInfo.phone = phoneItem.prefix + "-" + phoneItem.code;

          // Mobile
          let phoneCopy = dataFormCopy.phone;
          dataFormCopy.phone = phoneCopy.prefix + "-" + phoneCopy.code;
          this.$emit("change", dataFormCopy, this.introduction);
        } else {
          validateFormLocation(object, this.$refs["dataForm"]);
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-form-item__content {
    line-height: 35px !important;
  }
}

.shares-info-table {
  table-layout: fixed;
  width: 100%;

  tr > th {
    padding: 12px 0;
    border-bottom: 1px solid #f0f5fa;
  }
  tbody > tr > td {
    padding: 12px 5px;
  }
}

.representativeWrap {
  font-size: 14px;
  color: #0060ff;
  font-weight: bolder;
  padding: 10px 15px;
  background: #eceff9;
  margin-bottom: 20px;
  border-radius: 4px;
}

.malaysia-address-block {
  margin-top: 10px;
}

.service-address-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
